<div
    class="shi"
    [ngStyle]="{ 'background-color': colorMap[color!] || defaultColor }">
    <div class="shi__container">
        <img
            [src]="assetsPath + (iconMap[color!] || defaultIcon)"
            [width]="20"
            [height]="20"
            [alt]="label" />
        <span [ngStyle]="{ color: textColorMap[color!] || defaultTextColor }">{{ label }}</span>
    </div>
    <span [ngStyle]="{ color: textColorMap[color!] || defaultTextColor }">{{ value ?? 0.0 | number : '1.1-1' }}</span>
</div>
